import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Check } from 'lucide-react';

import { cn } from '@/lib/utils';

const STEP_KEYS = ['sources', 'planning', 'simulation'] as const;

interface CreateScenarioStepperProps {
  /** Zero-based index into the steps. */
  activeStep: number;
}

const CreateScenarioStepper: FC<CreateScenarioStepperProps> = ({
  activeStep,
}) => {
  const { t } = useTranslation();

  return (
    <ol
      aria-label={t('scenarios.create.steps.label')}
      className='flex flex-wrap items-center gap-2 text-sm'>
      {STEP_KEYS.map((key, index) => {
        const isDone = index < activeStep;
        const isActive = index === activeStep;
        return (
          <li
            key={key}
            aria-current={isActive ? 'step' : undefined}
            className='flex items-center gap-2'>
            {index > 0 && (
              <span
                aria-hidden='true'
                className='h-px w-8 bg-border'
              />
            )}
            <span
              className={cn(
                'grid size-6 place-items-center rounded-full border text-xs',
                isActive && 'border-primary bg-primary text-primary-foreground',
                isDone && 'border-transparent bg-muted'
              )}>
              {isDone ? <Check className='size-3' /> : index + 1}
            </span>
            <span
              className={cn(
                isActive ? 'font-semibold' : 'text-muted-foreground'
              )}>
              {t(`scenarios.create.steps.${key}`)}
            </span>
          </li>
        );
      })}
    </ol>
  );
};

export default CreateScenarioStepper;
